import * as React from "react";
import { SOON_PREF, soonMinutes } from "@/lib/callbacks";
import { useSaveUiPrefs, useUiPrefs } from "@/lib/queries";

/**
 * The minutes on a rep's "In … min" callback pick, kept in their own `ui_prefs` so the pick reads
 * the same on the phone's outcome window and on Set outcome, on any browser they sign in on. A
 * change shows at once and is saved behind it; a save that fails costs only the remembering.
 */
export function useCallbackMinutes(): { value: number; set: (minutes: number) => void } {
  const prefs = useUiPrefs();
  const { mutate } = useSaveUiPrefs();
  const [picked, setPicked] = React.useState<number | null>(null);
  const set = React.useCallback(
    (minutes: number) => {
      setPicked(minutes);
      mutate({ [SOON_PREF]: minutes });
    },
    [mutate],
  );
  return { value: picked ?? soonMinutes(prefs.data?.[SOON_PREF]), set };
}
